import Image from 'next/image'
import { useSearchParams } from 'next/navigation'
import { Number, Map, MapAlt, Layout } from '../components'

const defaultDirectory = [
    {
        name: 'McDonalds',
        walking: 1,
        driving: 0,
        className:"top-[62%] left-[82.58%]"
      },
      {
        name: 'KFC',
        walking: 1,
        driving: 0,
        className:"top-[62%] left-[79.73%]"
      },
      {
        name: 'A&W',
        walking: 1,
        driving: 1,
        className:"left-[83.96%] top-[75.42%]"
      },
      {
        name: 'Lake of the Woods Cannabis',
        walking: 4,
        driving: 1,
        className:"left-[79%] top-[54.87%]"
      },
      {
        name: 'Canadian Tire',
        walking: 5,
        driving: 1,
        className:"left-[94.34%] top-[81.73%]"
      },
      {
        name: 'Walmart',
        walking: 6,
        driving: 1,
        className:"left-[89.4%] top-[92.8%]"
      },
      {
        name: 'Dog Park',
        walking: 7,
        driving: 1,
        className:"left-[84.56%] top-[88.10%]"
      },
      {
        name: 'K-Sports Marina',
        walking: 8,
        driving: 1,
        className:"left-[89.36%] top-[51.42%]"
      },
      {
        name: 'Kenora Downtown',
        walking: 17,
        driving: 3,
        className:"left-[54.21%] top-[31.29%]"
      },
      {
        name: 'Kenora Harbourfront',
        walking: 20,
        driving: 4,
        className:"left-[47.24%] top-[22.27%]"
      },
]

const restaurantDirectory = [
    {
      name: 'McDonalds',
      walking: 1,
      driving: 0,
      className:"top-[62%] left-[82.58%]"
    },
    {
      name: 'KFC',
      walking: 1,
      driving: 0,
      className:"top-[62%] left-[79.73%]"
    },
    {
      name: 'A&W',
      walking: 1,
      driving: 1,
      className:"left-[83.96%] top-[75.42%]"
    },
    {
      name:'Yesterday\'s Restaurant',
      walking:4,
      driving:1,
      className:"left-[81.5%] top-[54.87%]"
    },
    {
      name:'Ye Olde Chip Truck',
      walking:17,
      driving:3,
      className:"left-[54%] top-[33.29%]"
    },
    {
      name:'Ho Ho Chinese Food',
      walking:18,
      driving:3,
      className:"left-[52.5%] top-[27.5%]"
    },
    {
      name:'Kurry',
      walking:18,
      driving:3,
      className:"left-[52%] top-[31.5%]"
    },
    {
      name:'Sushi 251',
      walking:18,
      driving:3,
      className:"left-[50%] top-[36%]"
    },
    {
      name:'Plaza',
      walking:18,
      driving:3,
      className:"left-[50%] top-[27%]"
    },
    {
      name:'Bob\'s Burgers',
      walking:18,
      driving:3,
      className:"left-[48%] top-[29.5%]"
    },
]
const schema = {
  "@context": "http://schema.org",
  "@type": "Map",
  'mapType':'TransitMap'
}
const NearBy = () => {
    const directory = useSearchParams()?.get('d')
    return(
      <Layout currentPage="nearby">
      <div className="w-full flex justify-center pt-10">
       <MapAlt directory={directory || 'none'}/>
       </div>
       <script type="application/ld+json" dangerouslySetInnerHTML={{__html:JSON.stringify(schema)}}/>
       </Layout> 
    )
}
export default NearBy
